// @copyright  2006 - 2023 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'project-checklist-task-user.page.title': 'Project Checklist Task Users',
    'project-checklist-task-user.page.bin.title': 'Binned Task Users',
    'project-checklist-task-user.page.search_results': 'Search Results',
    'project-checklist-task-user.page.create.title': 'Create New Task User',
    'project-checklist-task-user.page.search.title': 'Find Task Users',
    'project-checklist-task-user.page.edit.title': 'Edit Task User',
    'project-checklist-task-user.page.view.title': 'View Task User',
    'project-checklist-task-user.page.all': 'All',

    'project-checklist-task-user.button.cancel': 'Cancel',
    'project-checklist-task-user.button.select': 'Select',
    'project-checklist-task-user.button.find': 'Find Task Users',
    'project-checklist-task-user.button.search': 'Apply',
    'project-checklist-task-user.button.create': 'Create Task User',
    'project-checklist-task-user.button.new': 'New Task User',
    'project-checklist-task-user.button.save': 'Save Changes',
    'project-checklist-task-user.button.bin': 'Bin',
    'project-checklist-task-user.button.empty': 'Empty Bin',
    'project-checklist-task-user.button.delete': 'Permanently Delete',
    'project-checklist-task-user.button.edit': 'Edit',
    'project-checklist-task-user.button.restore': 'Restore',
    'project-checklist-task-user.button.reset': 'Reset',

    'project-checklist-task-user.placeholder.search': 'Search task users',

    'project-checklist-task-user.link.create_first_project_checklist_task_user': 'Click here to create your first task user',
    'project-checklist-task-user.link.project_checklist_task_users': ' Return to Task Users',
    'project-checklist-task-user.link.bin': 'Binned Task Users',
    'project-checklist-task-user.link.retry': 'Click here to retry',

    'project-checklist-task-user.checkbox.all': 'Check All',
    'project-checklist-task-user.checkbox.actions_label': 'with selected',

    'project-checklist-task-user.label.project_checklist_task_name': 'Project Checklist Task',
    'project-checklist-task-user.label.is_owner': 'Is Owner',
    'project-checklist-task-user.label.username': 'Username',

    'project-checklist-task-user.sort.field_label': 'Field',
    'project-checklist-task-user.sort.direction_label': 'Direction',
    'project-checklist-task-user.sort.direction_ascending': 'Ascending',
    'project-checklist-task-user.sort.direction_descending': 'Descending',

    'project-checklist-task-user.modal.title.project_checklist_task_user_bin': 'Bin Task User',
    'project-checklist-task-user.modal.title.project_checklist_task_user_bin_empty': 'Delete All Binned Task Users',
    'project-checklist-task-user.modal.title.project_checklist_task_user_delete_permanently': 'Delete Task User',
    'project-checklist-task-user.modal.title.project_checklist_task_user_restore': 'Restore Task User',

    'project-checklist-task-user.modal.message.project_checklist_task_user_bin': 'Are you sure that you want to move this task user to the bin ? | Are you sure that you want to move these task users to the bin ?',
    'project-checklist-task-user.modal.message.project_checklist_task_user_bin_empty': 'Are you sure that you want to permanently delete all binned task users? This action cannot be undone!',
    'project-checklist-task-user.modal.message.project_checklist_task_user_delete_permanently':
        'Are you sure that you want to permanently delete this task user? This action cannot be undone. | Are you sure that you want to permanently delete these task users? This action cannot be undone.',
    'project-checklist-task-user.modal.message.project_checklist_task_user_restore': 'Are you sure that you want to restore this task user? | Are you sure that you want to restore these task users?',

    'project-checklist-task-user.success.message.project_checklist_task_user_created': 'Your task user has been created',
    'project-checklist-task-user.success.message.project_checklist_task_user_updated': 'Your task user has been updated',
    'project-checklist-task-user.success.message.project_checklist_task_user_restored': 'Your task user has been restored | All selected task users were restored',
    'project-checklist-task-user.success.message.project_checklist_task_user_deleted': 'Your task user has been permanently deleted | All selected task users were permanently deleted',
    'project-checklist-task-user.success.message.binned_project_checklist_task_users': 'Your task user was moved to the bin | All selected task users were moved to the bin',
    'project-checklist-task-user.success.message.project_checklist_task_user_bin_emptied': 'All binned task users were permanently deleted!',

    'project-checklist-task-user.error.message.binned_project_checklist_task_users': 'This task user was already moved to the bin | These task users were already moved to the bin',
    'project-checklist-task-user.error.message.project_checklist_task_user_bin_emptied': 'All binned task users were already deleted',
    'project-checklist-task-user.error.message.project_checklist_task_user_deleted': 'This task user was already permanently deleted | These task users were already permanently deleted',
    'project-checklist-task-user.error.message.project_checklist_task_user_restored': 'This task user was already restored | These task users were already restored',
    'project-checklist-task-user.error.message.error_loading_page': 'Sorry, there was an error loading task user.| Sorry, there was an error loading task users.',

    'project-checklist-task-user.message.search.no_binned_project_checklist_task_users': "You don't have any binned task users.",
};
